/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react'

import { graphql, Link } from 'gatsby'
import styled from 'styled-components'

import Layout from '../components/core/layout'
import SEO from '../components/core/seo'
import AccreditedYouBet from '../components/cross-template-statics/AccreditedYouBet'
import FormCampusSelect from '../components/forms/FormCampusSelect'
import FormWrapperGray from '../components/forms/FormWrapperGray'
import HeroChevron from '../components/heroes/HeroChevron'
import PyramidPerson from '../components/reusables/PyramidPerson'
import TestimonialSlider from '../components/reusables/TestimonialSlider'
import TextBoxOverImage from '../components/reusables/TextBoxOverImage'
import BigNumberStatsHome from '../components/specific-to-template/home/BigNumberStatsHome'
import VideoWithThumbnails from '../components/specific-to-template/home/VideoWithThumbnails'
import { above, colors, fontSize, space } from '../style/design-system'
import { studentInfo } from '../utils/static-data/studentInfo'

const Home = ({ className, data }) => (
  <Layout>
    <SEO
      title="UMA: Healthcare Career School | Online & Blended Programs"
      description="Ultimate Medical Academy is a student-first, nonprofit healthcare education institute offering online & blended/on-campus programs. Pursue your journey today."
      noUmaInTitle
      ogImage={data.videoPoster.publicURL}>
      <link rel="canonical" href="https://www.ultimatemedical.edu/" />
      <meta name="facebook-domain-verification" content="sv03b0gjsw5k1wipsm726owazwi62v" />
      <script type="application/ld+json">
        {`{"@context": "https://schema.org",
          "@type": "CollegeOrUniversity",
          "name": "Ultimate Medical Academy",
          "alternateName": "UMA",
          "url": "https://www.ultimatemedical.edu/",
          "logo": "https://www.ultimatemedical.edu/static/83988c8a5e8eb28067936516f9d1cb97/UMA-logo.jpg",
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "888-213-4473",
            "contactType": "General Information",
            "contactOption": "TollFree",
            "areaServed": "US",
            "availableLanguage": "en"
          },
          "sameAs": [
            "https://www.facebook.com/umaonline/",
            "https://twitter.com/UltimateMedical",
            "https://www.instagram.com/ultimatemedicalacademy/",
            "https://www.youtube.com/c/UltimateMedicalAcademy",
            "https://www.linkedin.com/school/ultimate-medical-academy/",
            "https://www.pinterest.com/ultimatemedical/",
            "https://en.wikipedia.org/wiki/Ultimate_Medical_Academy"
          ]
        }`}
      </script>
    </SEO>

    <div className={className}>
      <div className="hide-overflow">
        <HeroChevron
          className="hero"
          backgroundImage={{
            className: 'd-none d-sm-block',
            image: data.heroImgLg.childImageSharp.gatsbyImageData,
          }}
          backgroundImageMobile={{
            className: 'd-sm-none',
            image: data.heroImgSm.childImageSharp.gatsbyImageData,
            objectPosition: '50% -75px',
          }}
          borderColor={colors.dev.green.e(0.9)}
          displayOverflow>
          <h1 className="h1 mt-0 white">Train for your calling in&nbsp;healthcare.</h1>
          <p className="white">Take the first step toward your future.</p>
          <Link to="/future-students/programs/" className="btn btn-green">
            Find Your Program&nbsp;&gt;
          </Link>
        </HeroChevron>

        <main>
          <div className="container pb-9 pt-14 pt-sm-10">
            <div className="row">
              <div className="col-10 offset-1 col-md-8 offset-md-3 col-lg-7 offset-lg-4 px-7">
                <p>
                  Ultimate Medical Academy has been committed to helping students succeed in healthcare careers for the
                  past {studentInfo.yearsInBusiness} years. That’s why we offer students a connected support system from
                  the start of their education to beyond graduation.
                </p>
                <p>
                  UMA is a nonprofit allied health school with a national presence and we’re passionate about our
                  students. Let us help you find your passion, too.
                </p>
                <p className="mb-0">
                  <Link className="btn btn-outline-black" to="/future-students/programs/">
                    Find Your Program&nbsp;&gt;
                  </Link>
                </p>
              </div>
            </div>
          </div>

          <div className="section--support py-8">
            <div className="triangle" />
            <div className="container">
              <div className="row">
                <div className="col-10 offset-1 col-lg-5 offset-lg-1 mb-9 mb-lg-0 px-7 px-lg-8 healthcare-heroes-col">
                  <h2 className="blue mt-0 mb-6 pl-4">See why we can’t help but&nbsp;care.</h2>
                  <VideoWithThumbnails />
                  {/* <VideoLazyload
                  displayPlayIcon
                  className="video-wrapper"
                  posterAlt="Care Pays Back Video Poster"
                  posterGatsbyImg={{
                    image: data.videoPoster.childImageSharp.gatsbyImageData,
                  }}>
                  <YouTubeEmbed autoplay title="UMA" videoId="u3VVs4wwVQI" />
                </VideoLazyload> */}
                </div>
                <div className="col-10 offset-1 col-lg-4 offset-lg-0 px-7 px-lg-8">
                  <h2 className="mt-0 blue">Experience exceptional support.</h2>
                  <p>
                    UMA has a team dedicated to each student, assisting with academic support, technical support, job
                    search guidance, mock interviews, financial aid, and more.
                  </p>
                  <Link to="/future-students/student-services/" className="btn btn-outline-black">
                    Your Support Team&nbsp;&gt;
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <FormWrapperGray>
            <FormCampusSelect includeUserErrorModal className="inline-form" />
          </FormWrapperGray>

          {/* 
          <div className="covid-19">
            COVID-19: UMA continues to serve its students
            <br className="d-sm-none" /> through this difficult time.{' '}
            <Link to="/covid-19/">
              <span className="nowrap">Learn More</span>
            </Link>
          </div>
        */}

          <div className="section--career-team position-relative d-flex">
            <TextBoxOverImage
              className="py-lg-12"
              gatsbyImageMobile={{
                image: data.careerLg.childImageSharp.gatsbyImageData,
                objectPosition: 'center top',
              }}
              gatsbyImage={{
                image: data.careerLg.childImageSharp.gatsbyImageData,
                objectPosition: '50% top',
              }}
              bootstrapClasses="col-lg-7 offset-lg-5"
              minHeightOverride="400px"
              childBootstrapClasses="color--white text-center col-xl-8 offset-xl-2">
              <h2 className="h1 mt-0 mb-2 white">Your career dreams.</h2>
              <div className="h2 white mt-0">Our career team.</div>
              <p className="white">
                Your career path assistance starts well before you graduate. We’ll help you showcase your strengths with
                a personalized resume and build your confidence with mock interview practice.
              </p>
              <a href="/future-students/career-services/" className="btn btn-outline-white">
                Career Services&nbsp;&gt;
              </a>
            </TextBoxOverImage>
          </div>

          <PyramidPerson
            gatsbyImage={{
              image: data.financialAidImg.childImageSharp.gatsbyImageData,
            }}
            pyramidColor="green">
            <h2 className="h1 mt-0 blue">
              Financial aid.
              <br />
              You've got options.
            </h2>
            <p>
              Worrying about how to pay for your education shouldn’t get in the way of your future. Let our Student
              Finance advisors help you understand the options for which you might qualify.
            </p>
            <Link to="/future-students/financial-aid/" className="btn btn-outline-black">
              Financial Aid&nbsp;&gt;
            </Link>
          </PyramidPerson>

          <TestimonialSlider testimonials={data.testimonials.edges} heading="Watch our students' stories." />

          <BigNumberStatsHome />

          <AccreditedYouBet />
        </main>
      </div>
    </div>
  </Layout>
)

export default styled(Home)`
  .covid-19 {
    background-color: ${colors.dev.teal.d()};
    text-align: center;
    color: #fff;
    padding: ${space.e};
    ${above.sm`
      padding: ${space.f};
    `}
    a {
      color: #fff;
      text-decoration: underline;
    }
  }

  .section--support {
    overflow: hidden;
    position: relative;

    .triangle {
      background-color: ${colors.dev.green.e()};
      position: absolute;
      right: 0;
      bottom: 0;
      transform: translate(50%, 50%) rotate(45deg);
      width: 35%;
      height: 125rem;
    }
  }

  .healthcare-heroes-col {
    ${above.lg`
      border-right: 1px solid black;
    `}
  }

  .section--career-team {
    .h2 {
      font-weight: normal;
      font-size: ${fontSize.k};
    }
  }

  .hero img {
    ${above.lg`
      object-position: 100px center;
    `}
  }
`

export const query = graphql`
  {
    videoPoster: file(absolutePath: { regex: "/ychbc/ychbc-video-poster.webp/" }) {
      publicURL
      childImageSharp {
        gatsbyImageData(width: 600, quality: 85, placeholder: NONE, layout: CONSTRAINED)
      }
    }
    heroImgLg: file(absolutePath: { regex: "/home/hero-desktop.webp/" }) {
      childImageSharp {
        gatsbyImageData(width: 1920, quality: 85, placeholder: NONE, layout: FIXED)
      }
    }
    heroImgSm: file(absolutePath: { regex: "/home/hero-mobile.webp/" }) {
      childImageSharp {
        gatsbyImageData(width: 575, quality: 85, placeholder: NONE, layout: FIXED)
      }
    }
    supportVideoPoster: file(absolutePath: { regex: "/home/support-video-poster.png/" }) {
      childImageSharp {
        gatsbyImageData(width: 600, quality: 85, placeholder: NONE, layout: CONSTRAINED)
      }
    }
    careerSm: file(absolutePath: { regex: "/home/career-lg.jpg/" }) {
      childImageSharp {
        gatsbyImageData(width: 992, quality: 85, placeholder: NONE, layout: FIXED)
      }
    }
    careerLg: file(absolutePath: { regex: "/home/career-lg.jpg/" }) {
      childImageSharp {
        gatsbyImageData(quality: 85, placeholder: NONE, layout: FULL_WIDTH)
      }
    }
    financialAidImg: file(absolutePath: { regex: "/home/student-finance.png/" }) {
      childImageSharp {
        gatsbyImageData(width: 425, quality: 85, placeholder: NONE, layout: CONSTRAINED)
      }
    }
    testimonials: allWpTestimonial(
      filter: { uri: { regex: "/leticia-b|jennifer-w|dominique-b|joshua-a|angelica-v|miguel-r|heather-r|brittney-j/" } }
    ) {
      edges {
        node {
          metaReviewerName
          metaReviewerVideo
          excerpt
          featuredImage {
            node {
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 700, placeholder: NONE, layout: CONSTRAINED)
                }
              }
            }
          }
        }
      }
    }
  }
`
